<template>
  <div class="boxs">
    <div class="item" @click="showUp">新增案例</div>
    <template>
      <el-dialog class="editUp" center :visible.sync="dialogVisible" width="40%">
        <div slot="title" class="title">
          <span>新增案例</span>
        </div>
        <!-- <div class="label">
                  <span>指示器：</span> <el-radio v-model="radio" label="1">显示</el-radio>
                  <el-radio v-model="radio" label="2">不显示</el-radio>
                </div> -->
        <div class="table">
          <el-form :model="form" label-width="120px" :rules="rules" ref="ruleForm">
            <el-form-item label="案例标题" prop="title">
              <el-input v-model="form.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="缩阅图" prop="thumbnail">
              <div class="upimg">
                <UploadImg @onSuccess="onSuccess">
                  <img v-if="form.thumbnail" :src="form.thumbnail" class="avatar" style="width: 100%;">
                  <i v-else size="50" class="el-icon-plus avatar-uploader-icon"></i>
                </UploadImg>
                <p>建议图片尺寸400*260</p>
              </div>
            </el-form-item>
            <el-form-item label="所属区域" prop="address">
              <el-select v-model="form.address" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="案例标签" prop="label">
              <el-select v-model="form.label" placeholder="请选择" style="width: 100%;">
                <el-option v-for="item in options" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="其它标签">
              <el-input type="text" placeholder="请输入标签名称" v-model="form.labelMore">
              </el-input>
              <div class="msg">
                <p>注：多个用;分隔</p>
              </div>

            </el-form-item>
            <el-form-item label="案例简介" prop="content">
              <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.content">
              </el-input>
            </el-form-item>
            <!-- <el-form-item label="案例文件" prop="fileUrl">
              <UploadPdf @onSuccess="UpSuccessPdf">
                <div class="upBtn">
                  <div>
                    <el-button size="small" type="primary">文件上传</el-button>
                  </div>
                  <div v-if="form.fileUrl" class="text">文件地址：{{ form.fileUrl }}</div>
                </div>

              </UploadPdf>
            </el-form-item>
            <el-form-item label="案例亮点">
              <UploadImgMore ref="filelist" @onReturn="onReturn"></UploadImgMore>
            </el-form-item> -->

          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="onSave">立即添加</el-button>
        </span>
      </el-dialog>
    </template>
  </div>
</template>
        
<script>
import UploadImg from "./uploadImg.vue"
// import UploadImgMore from "./uploadImgMore.vue"
// import UploadPdf from "./uploadPdf.vue"
import { getCommonDataList } from "@/api/news.js"
import { addClassicCase } from "@/api/case.js"
import cityJson from "../components/map.json"
import { createMapOptions } from "@/utils/mapLocale";
export default {
  components: {
    UploadImg,
    // UploadPdf,
    // UploadImgMore
  },
  data() {
    return {
      dialogVisible: false,
      radio: '1',
      form: {},
      editData: [],
      imageUrl: "",
      typeList: [],
      provs: [],
      linkData: "",
      options: ['测绘服务', '数据服务', '数智应用'],
      rules: {
        address: [
          { required: true, message: '请选择区域', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 100, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        label: [
          { required: true, message: '请输入选择标签', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请输入资讯简介', trigger: 'blur' },
          { min: 3, max: 500, message: '长度在 3 到 500 个字符', trigger: 'blur' }
        ],
        thumbnail: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        fileUrl: [
          { required: true, message: '请输入详情链接', trigger: 'blur' },
        ],
      }
    }
  },
  mounted() {
    this.provs = createMapOptions(cityJson, this.$store.state.language);
  },
  methods: {
    showUp() {
      this.$router.push({
        path: '/caseMod'
      })
      // this.editData = [];
      // this.dialogVisible = true;
      // this.form = {};
      // // this.$nextTick(() => {
      // //   this.$refs.filelist.setfileList([])
      // // })
      // getCommonDataList({ commonData: 'information', isRelease: this.$store.state.editStatus }).then(res => {
      //   this.typeList = res.data;
      // })
    },
    del(e) {
      this.editData.splice(e.$index, 1)
    },
    onSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let params = {
            ...this.form,
            isRelease: 0,
          }
          // this.$refs.filelist.getData(params);
          addClassicCase(params).then(res => {
            if(res.code == 200) {
              this.$message.success('操作成功')
              this.onReturn()
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    onReturn() {
      this.dialogVisible = false;
      this.$emit('onReturn')
    },
    onSuccess(e) {
      this.$set(this.form, 'thumbnail', e)
    },
    UpSuccessPdf(e) {
      this.$set(this.form, 'fileUrl', e.fileUrl)
    },
    highlightsList(e) {
      let arr = [];

      this.form.highlightsList.push({
        fileUrl: e.fileUrl
      })
    }
  }
}
</script>
        
<style lang="scss" scoped>
.boxs {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: left;

  &:hover {
    border: 1px dashed #ccc;
  }

  .item {
    padding: 5px 10px;
    background: #007ffe;
    font-style: normal;
    align-items: center;
    display: none;

    cursor: pointer;
    color: #fff;

    &:first-child {
      border-bottom-right-radius: 4px;
    }
  }

  &:hover {
    .item {
      display: inline-flex;
      font-size: 14px;
    }
  }
}

::v-deep .editUp {
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;

    span {
      &:nth-child(2) {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .label {
    display: flex;
    align-items: center;
  }

  .table {
    margin-top: 20px;

    .img {
      width: 100px;
      height: 50px;
    }

    .upBtn {
      text-align: left;
    }

    .msg {
      p {
        font-size: 12px;
        color: #999;
      }
    }

    .upimg {
      width: 150px;
      height: 100px;
      margin-bottom: 20px;

      p {
        font-size: 12px;
        color: #999;
      }

      .avatar-uploader {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-upload {
          display: flex;
          align-items: center;
          justify-content: center;

          .el-icon-plus {
            font-size: 30px;
            color: #999;
          }
        }
      }
    }
  }

  .dialog-foote {
    text-align: center;
    display: flex;
    justify-content: center;
  }
}
</style>
